import type { ComponentProps } from "react"
import FormControl from "./FormControl"
import { JsonSchemaField } from "@/schema"
import type { JsonField } from "@/schema"

export type Props = Omit<
  ComponentProps<typeof JsonSchemaField>,
  "value" | "onChange" | "error"
> & {
  name: string
}

export default function FormJsonSchemaField({ name, ...fieldProps }: Props) {
  return (
    <FormControl name={name} required>
      {({ field: { onChange, value }, error }) => (
        <JsonSchemaField
          value={JSON.parse(value as string) as JsonField}
          onChange={(schema) => {
            onChange(JSON.stringify(schema))
          }}
          {...fieldProps}
          error={error}
        />
      )}
    </FormControl>
  )
}
